{
  "common": {
    "loading": "Laden...",
    "cancel": "Annuleren",
    "save": "Opslaan",
    "save_changes": "Wijzigingen opslaan",
    "delete": "Verwijderen",
    "edit": "Bewerking",
    "close": "Dichtbij",
    "submit": "Indienen",
    "saving": "Besparing...",
    "sending": "Verzenden...",
    "error": "Fout",
    "success": "Succes",
    "warning": "Waarschuwing",
    "note": "Opmerking",
    "no_data": "Geen gegevens",
    "yes": "Ja",
    "no": "Nee",
    "back": "Rug",
    "next": "Volgende",
    "previous": "Vorig",
    "search": "Zoekopdracht",
    "filter": "Filter",
    "all": "Alle",
    "none": "Geen",
    "select": "Select",
    "required": "Vereist",
    "optional": "Optioneel",
    "actions": "Acties",
    "status": "Status",
    "date": "Datum",
    "time": "Tijd",
    "name": "Naam",
    "email": "E-mail",
    "confirm": "Bevestigen",
    "add": "Toevoegen",
    "done": "Klaar",
    "unknown": "Onbekend",
    "days": "dagen",
    "to": "tot"
  },
  "time": {
    "day": "dag",
    "days": "dagen",
    "hour": "uur",
    "hours": "uren",
    "week": "week",
    "weeks": "weken",
    "month": "maand",
    "months": "maanden",
    "year": "jaar",
    "years": "jaren",
    "today": "Vandaag",
    "tomorrow": "Morgen",
    "yesterday": "Gisteren"
  },
  "status": {
    "pending": "In behandeling",
    "approved": "Goedgekeurd",
    "rejected": "Afgewezen",
    "cancelled": "Geannuleerd",
    "active": "Actief",
    "inactive": "Inactief",
    "deleted": "Verwijderd",
    "connected": "Aangesloten",
    "disconnected": "Verbinding verbroken",
    "available": "Beschikbaar",
    "coming_soon": "Binnenkort beschikbaar"
  },
  "nav": {
    "dashboard": "Dashboard",
    "planner": "Planner",
    "team": "Team",
    "requests": "Verzoeken",
    "calendar": "Kalender",
    "settings": "Instellingen",
    "audit_trail": "Auditspoor",
    "billing": "Facturering",
    "help": "Hulp",
    "help_center": "Helpcentrum",
    "profile": "Profiel",
    "my_balances": "Mijn saldo's",
    "leave_history": "Verlofhistorie",
    "restart_tour": "Tour herstarten",
    "logout": "Uitloggen",
    "upgrade": "Upgrade naar Pro",
    "upgrade_subtitle": "Ontgrendel alle functies",
    "view_plans": "Bekijk plattegronden"
  },
  "header": {
    "profile_settings": "Profielinstellingen",
    "my_profile": "Mijn profiel",
    "workspace": "Werkruimte",
    "leave_balances": "Verlofsaldo",
    "no_balances": "Geen verlofsaldo gevonden."
  },
  "balance": {
    "unlimited": "Onbeperkt",
    "days_left": "dagen resterend",
    "used": "gebruikt",
    "remaining": "overig",
    "of": "van"
  },
  "trial": {
    "ends_today": "Je proefperiode eindigt vandaag!",
    "ends_tomorrow": "Je proeftijd eindigt morgen!",
    "ends_in_days": "De proefperiode eindigt over {dagen} dagen.",
    "upgrade_now": "Upgrade nu"
  },
  "feature_locked": {
    "title": "{functie} is niet beschikbaar in uw abonnement.",
    "description": "Upgrade je abonnement om deze en andere functies te ontgrendelen.",
    "button": "Bekijk plattegronden"
  },
  "dashboard": {
    "title": "Dashboard",
    "out_today": "Vandaag uitgebracht",
    "out_on_date": "Uitgebracht op {datum}",
    "no_absences": "Geen afwezigheden",
    "upcoming": "Aankomende afwezigheden",
    "upcoming_empty": "Geen afwezigheden deze week.",
    "my_balance": "Mijn verlofsaldo",
    "my_balances": "Mijn saldo's",
    "no_balance_data": "Geen saldo-gegevens",
    "next_holiday": "Volgende officiële feestdag",
    "no_holidays": "Geen aankomende feestdagen",
    "next_vacation": "Mijn volgende vakantie",
    "nothing_booked": "Niets geboekt!",
    "upcoming_birthdays": "Aankomende verjaardagen",
    "no_birthdays": "Geen verjaardagen in de nabije toekomst",
    "birthday_today": "Vandaag!",
    "birthday_in_days": "over {days} {unit}",
    "everyone_in_office": "Iedereen is vandaag op kantoor.",
    "request_leave": "Verlof aanvragen",
    "view_calendar": "Bekijk de kalender",
    "view_planner": "Planner bekijken",
    "contact_support": "Neem contact op met de ondersteuning."
  },
  "support": {
    "title": "Neem contact op met de ondersteuning.",
    "success_title": "Bericht verzonden!",
    "success_message": "We nemen zo snel mogelijk contact met u op.",
    "intro": "Heeft u hulp nodig? Stuur ons een bericht en we nemen zo snel mogelijk contact met u op.",
    "subject_label": "Onderwerp",
    "subject_placeholder": "Korte omschrijving van uw probleem",
    "message_label": "Bericht",
    "message_placeholder": "Beschrijf uw probleem of vraag zo gedetailleerd mogelijk...",
    "send_button": "Bericht verzenden"
  },
  "requests": {
    "page_title": "Verlofverzoeken",
    "page_subtitle": "Verlofaanvragen beoordelen en beheren",
    "new_request": "Verlof aanvragen",
    "unpaid_confirm": "Slechts {paid} {unit} van deze aanvraag wordt gedekt door uw betaalde saldo. De resterende {unpaid} {unit} worden opgenomen als onbetaald verlof. Toch indienen?",
    "filter": {
      "pending": "In behandeling",
      "approved": "Goedgekeurd",
      "rejected": "Afgewezen",
      "all": "Alle",
      "all_employees": "Alle werknemers"
    },
    "table": {
      "employee": "Medewerker",
      "type": "Type",
      "dates": "Datums",
      "duration": "Duur",
      "status": "Status",
      "reason": "Reden",
      "actions": "Acties"
    },
    "action": {
      "approve": "Goedkeuren",
      "reject": "Afwijzen",
      "cancel": "Annuleren"
    },
    "empty": {
      "title": "Geen verzoeken gevonden",
      "pending": "Er zijn geen lopende verzoeken ter beoordeling.",
      "filtered": "Er zijn geen verlofaanvragen die overeenkomen met uw filter."
    },
    "modal": {
      "reject_title": "Verzoek afwijzen",
      "reason_label": "Reden voor afwijzing",
      "reason_placeholder": "Reden voor verlofaanvraag...",
      "reject_button": "Afwijzen",
      "request_title": "Verlof aanvragen",
      "employee_label": "Medewerker",
      "leave_type_label": "Type verlaten",
      "start_date_label": "Startdatum",
      "end_date_label": "Einddatum",
      "start_time_label": "Starttijd",
      "end_time_label": "Eindtijd",
      "reason_optional": "Reden (optioneel)",
      "submit_button": "Verzoek indienen",
      "submitting": "Verzenden...",
      "minimum_duration": "Minimaal: {duration} {unit}"
    }
  },
  "calendar": {
    "page_title": "Teamkalender",
    "page_subtitle": "Bekijk de afwezigheden en geplande verlofdata van het team.",
    "filters": {
      "button": "Filters"
    },
    "sync": {
      "title": "Synchroniseer je agenda",
      "description": "Koppel je persoonlijke agenda om goedgekeurd verlof automatisch te synchroniseren."
    },
    "connect": {
      "google": "Google Agenda",
      "microsoft": "Microsoft Agenda"
    },
    "action": {
      "disconnect": "Verbinding verbreken",
      "sync_my_leave": "Mijn verlof synchroniseren",
      "sync_team_leave": "Sync Team vertrekt"
    },
    "connecting": "Verbinden...",
    "syncing": "Synchroniseren...",
    "autosync": {
      "title": "Auto-synchronisatieteam vertrekt",
      "description": "Voeg automatisch goedgekeurd verlof van teamleden toe aan je agenda."
    },
    "filter": {
      "department_label": "Afdeling",
      "all_departments": "Alle afdelingen",
      "location_label": "Locatie",
      "all_locations": "Alle locaties",
      "leave_type_label": "Type verlaten",
      "all_types": "Alle soorten",
      "status_label": "Status",
      "all_status": "Alle status"
    },
    "nav": {
      "today": "Vandaag"
    },
    "view": {
      "day": "Dag",
      "week": "Week",
      "month": "Maand"
    },
    "legend": {
      "pending": "In behandeling",
      "holiday": "Vakantie"
    },
    "day_view": {
      "empty": "Geen bladeren op deze dag"
    },
    "more": "+{count} meer"
  },
  "team": {
    "page_title": "Team",
    "page_subtitle": "Beheer je teamleden",
    "tab": {
      "active": "Actief",
      "inactive": "Inactief",
      "deleted": "Verwijderd"
    },
    "add_user": "Gebruiker toevoegen",
    "import_from_slack": "Importeren vanuit Slack",
    "search_placeholder": "Zoek teamleden...",
    "table": {
      "name": "Naam",
      "email": "E-mail",
      "department": "Afdeling",
      "location": "Locatie",
      "manager": "Manager",
      "role": "Rol",
      "status": "Status",
      "birthday": "Verjaardag",
      "start_date": "Startdatum",
      "working_days": "Werkdagen",
      "actions": "Acties"
    },
    "filter": {
      "all_departments": "Alle afdelingen",
      "all_locations": "Alle locaties",
      "all_roles": "Alle rollen",
      "search": "Zoeken..."
    },
    "role": {
      "owner": "Eigenaar",
      "admin": "Beheerder",
      "approver": "Goedkeurder",
      "employee": "Medewerker"
    },
    "card": {
      "department": "Afdeling",
      "location": "Locatie",
      "manager": "Manager",
      "email": "E-mail",
      "birthday": "Verjaardag",
      "start_date": "Startdatum",
      "working_days": "Werkdagen",
      "no_department": "Geen afdeling",
      "no_location": "Geen locatie",
      "no_manager": "Geen manager"
    },
    "action": {
      "edit": "Bewerken",
      "view": "Bekijken",
      "deactivate": "Deactiveren",
      "activate": "Activeren",
      "delete": "Verwijderen",
      "restore": "Herstellen",
      "permanent_delete": "Permanent verwijderen",
      "adjust_balance": "Saldo aanpassen",
      "view_history": "Geschiedenis bekijken",
      "send_invite": "Uitnodiging versturen"
    },
    "empty": {
      "title": "Geen teamleden gevonden",
      "description": "Er zijn geen teamleden die aan je zoekcriteria voldoen.",
      "active": "Er zijn geen actieve teamleden.",
      "inactive": "Er zijn geen inactieve teamleden.",
      "deleted": "Er zijn geen verwijderde teamleden.",
      "add_first": "Voeg je eerste teamlid toe",
      "import_hint": "Je kunt teamleden importeren vanuit Slack."
    },
    "modal": {
      "edit_title": "Teamlid bewerken",
      "add_title": "Teamlid toevoegen",
      "view_title": "Teamlid details",
      "personal_info": "Persoonlijke gegevens",
      "employment_info": "Dienstverbandgegevens",
      "name_label": "Naam",
      "email_label": "E-mail",
      "department_label": "Afdeling",
      "location_label": "Locatie",
      "manager_label": "Manager",
      "role_label": "Rol",
      "birthday_label": "Verjaardag",
      "start_date_label": "Startdatum",
      "working_days_label": "Werkdagen",
      "hours_per_week_label": "Uren per week",
      "select_department": "Selecteer afdeling",
      "select_location": "Selecteer locatie",
      "select_manager": "Selecteer manager",
      "select_role": "Selecteer rol",
      "no_manager": "Geen manager"
    },
    "toil": {
      "title": "Compensatieverlof (TOIL)",
      "add_button": "TOIL toevoegen",
      "hours_label": "Uren",
      "reason_label": "Reden",
      "date_label": "Datum",
      "balance": "TOIL-saldo",
      "no_entries": "Geen TOIL-gegevens"
    },
    "invite": {
      "title": "Lid uitnodigen",
      "email_label": "E-mailadres",
      "email_placeholder": "voer@email.in",
      "role_label": "Rol",
      "department_label": "Afdeling",
      "send_button": "Uitnodiging versturen",
      "success": "Uitnodiging succesvol verstuurd",
      "error": "Versturen van uitnodiging mislukt"
    },
    "bulk": {
      "title": "Bulk importeren",
      "import_button": "Bulk importeren",
      "select_all": "Alles selecteren",
      "deselect_all": "Alles deselecteren",
      "selected_count": "{count} geselecteerd",
      "import_selected": "Geselecteerde importeren",
      "no_users": "Geen gebruikers beschikbaar om te importeren",
      "success": "{count} gebruiker(s) succesvol geïmporteerd",
      "error": "Import mislukt"
    },
    "instances": {
      "title": "Verlofinstanties",
      "used": "Gebruikt",
      "remaining": "Resterend",
      "lifetime_limit": "Levenslange limiet",
      "no_limit": "Geen limiet"
    },
    "confirm": {
      "deactivate": "Weet je zeker dat je deze gebruiker wilt deactiveren?",
      "deactivate_warning": "De gebruiker kan niet meer inloggen of verlof aanvragen.",
      "delete": "Weet je zeker dat je deze gebruiker wilt verwijderen?",
      "delete_warning": "De gebruiker wordt verplaatst naar het tabblad 'Verwijderd'.",
      "permanent_delete": "Weet je zeker dat je {name} PERMANENT wilt verwijderen?",
      "permanent_delete_warning": "Deze actie kan niet ongedaan worden gemaakt. Alle verlofgeschiedenis en saldo's worden verwijderd.",
      "permanent_delete_final": "Dit is permanent! Klik op Bevestigen om door te gaan.",
      "restore": "Weet je zeker dat je deze gebruiker wilt herstellen?",
      "restore_info": "De gebruiker wordt teruggezet naar actieve status."
    },
    "error": {
      "load": "Laden van teamleden mislukt",
      "save": "Opslaan van wijzigingen mislukt",
      "deactivate": "Het deactiveren van de gebruiker is mislukt",
      "activate": "Het activeren van de gebruiker is mislukt",
      "delete": "Het verwijderen van de gebruiker is mislukt",
      "restore": "Het herstellen van de gebruiker is mislukt",
      "permanent_delete": "Het permanent verwijderen van de gebruiker is mislukt",
      "import": "Het importeren van gebruikers is mislukt",
      "invite": "Het versturen van de uitnodiging is mislukt"
    }
  },
  "settings": {
    "page_title": "Instellingen",
    "page_subtitle": "Configureer de instellingen en het beleid van uw werkruimte.",
    "access_denied": {
      "title": "Beheerdersrechten vereist",
      "message": "Je hebt beheerdersrechten nodig om toegang te krijgen tot de instellingen."
    },
    "tab": {
      "workspace": "Werkruimte",
      "departments": "Afdelingen",
      "locations": "Locaties",
      "holidays": "Vakantie",
      "compliance": "Naleving",
      "balances": "Beginsaldi",
      "notifications": "Meldingen",
      "integrations": "Integraties",
      "import": "Importeren",
      "data_management": "Gegevensbeheer",
      "locked_tooltip": "Upgrade om deze functie te ontgrendelen."
    },
    "workspace": {
      "title": "Werkruimte-instellingen",
      "name_label": "Werkruimtenaam",
      "visibility_label": "Laat zichtbaar",
      "visibility": {
        "all": "Iedereen kan alle vertrekken zien",
        "department": "Alleen de eigen afdeling bekijken",
        "approvers": "Alleen goedkeurders kunnen alles zien."
      },
      "save_button": "Wijzigingen opslaan"
    },
    "departments": {
      "title": "Afdelingen",
      "subtitle": "Deel je team in afdelingen in met aangepaste beleidsregels.",
      "add_button": "Afdeling toevoegen",
      "name_label": "Afdelingsnaam",
      "working_days_label": "Werkdagen",
      "hours_per_day_label": "Uren per dag",
      "approvers_label": "Goedkeurders",
      "notification_channel_label": "Meldingskanaal",
      "policies_button": "Beleid beheren",
      "edit_button": "Bewerking",
      "delete_button": "Verwijderen",
      "confirm_delete": "Weet je zeker dat je deze afdeling wilt verwijderen?",
      "no_departments": "Er zijn nog geen afdelingen aangemaakt."
    },
    "locations": {
      "title": "Locaties",
      "subtitle": "Beheer de kantoorlocaties en hun vakantiekalenders.",
      "add_button": "Locatie toevoegen",
      "name_label": "Locatienaam",
      "country_label": "Land",
      "timezone_label": "Tijdzone",
      "edit_button": "Bewerking",
      "delete_button": "Verwijderen",
      "no_locations": "Er zijn nog geen locaties aangemaakt."
    },
    "holidays": {
      "title": "Officiële feestdagen",
      "subtitle": "Beheer de feestdagen voor elke locatie.",
      "add_button": "Vakantie toevoegen",
      "location_label": "Locatie",
      "all_locations": "Alle locaties",
      "year_label": "Jaar",
      "name_label": "Naam van de feestdag",
      "date_label": "Datum",
      "half_day_label": "Halve dag",
      "edit_button": "Bewerking",
      "delete_button": "Verwijderen",
      "no_holidays": "Er zijn geen feestdagen voor deze locatie en dit jaar.",
      "import_button": "Importeer feestdagen"
    },
    "leave_types": {
      "title": "Soorten bladeren",
      "subtitle": "Configureer verlofsoorten en -rechten.",
      "add_button": "Voeg bladtype toe",
      "name_label": "Naam",
      "color_label": "Kleur",
      "unit_label": "Eenheid",
      "unit": {
        "days": "Dagen",
        "hours": "Uren"
      },
      "entitlement_label": "Standaardrecht",
      "unlimited": "Onbeperkt",
      "requires_approval_label": "Goedkeuring vereist",
      "allow_half_day_label": "Neem een ​​halve dag de tijd",
      "is_paid_label": "Betaald verlof",
      "carryover_label": "Maximale overdracht",
      "priority_label": "Prioriteit",
      "edit_button": "Bewerking",
      "delete_button": "Verwijderen",
      "no_leave_types": "Geen verloftypen geconfigureerd"
    },
    "notifications": {
      "title": "Meldingen",
      "subtitle": "Configureer hoe en wanneer meldingen worden verzonden.",
      "slack_channel_label": "Slack-kanaal",
      "email_notifications_label": "E-mailmeldingen",
      "daily_digest_label": "Dagelijkse samenvatting",
      "weekly_summary_label": "Wekelijkse samenvatting",
      "save_button": "Instellingen opslaan"
    },
    "integrations": {
      "title": "Integraties",
      "subtitle": "Koppel uw HR-tools en agenda's.",
      "connect_button": "Verbinden",
      "disconnect_button": "Verbinding verbreken",
      "sync_button": "Nu synchroniseren",
      "view_logs_button": "Logboeken bekijken",
      "last_sync": "Laatst gesynchroniseerd: {datum}",
      "never_synced": "Nooit gesynchroniseerd",
      "status": {
        "connected": "Aangesloten",
        "disconnected": "Niet verbonden",
        "error": "Fout"
      }
    },
    "data": {
      "title": "Gegevensbeheer",
      "subtitle": "Maak een back-up van uw gegevens of wis de werkruimtegegevens.",
      "current_data": "Actuele gegevens",
      "total_users": "Totaal aantal gebruikers",
      "admins": "Beheerders",
      "regular_users": "Regelmatige gebruikers",
      "leave_requests": "Verlofverzoeken",
      "backup": {
        "title": "Back-up downloaden",
        "description": "Download een volledige back-up van uw werkruimtegegevens als een JSON-bestand.",
        "button": "Back-up downloaden"
      },
      "google_drive": {
        "title": "Google Drive-back-up",
        "description": "Automatische dagelijkse back-ups naar Google Drive.",
        "connect_button": "Verbinden met Google Drive",
        "folder_label": "Back-upmap",
        "auto_backup_label": "Schakel automatische dagelijkse back-up in.",
        "backup_now_button": "Maak nu een back-up",
        "last_backup": "Laatste back-up: {datum}",
        "upgrade_message": "Automatische dagelijkse back-ups naar Google Drive zijn beschikbaar in het Business-abonnement."
      },
      "clear_users": {
        "title": "Niet-beheerdersgebruikers verwijderen",
        "description": "Verwijder alle gebruikers behalve beheerders en eigenaren. Hierdoor worden {count} gebruikers, hun verlofsaldo en alle openstaande verlofaanvragen verwijderd.",
        "warning": "Waarschuwing: Deze actie kan niet ongedaan worden gemaakt. Zorg ervoor dat u eerst een back-up downloadt.",
        "confirm_prompt": "Typ DELETE om te bevestigen",
        "confirm_description": "Hierdoor worden {count} gebruikers en al hun gegevens permanent verwijderd.",
        "button": "Niet-beheerdersgebruikers verwijderen",
        "confirm_button": "Gebruikers verwijderen bevestigen"
      },
      "clear_history": {
        "title": "Wis je verlofgeschiedenis",
        "description": "Verwijder alle verlofaanvragen en zet alle verlofsaldi terug op nul. Dit verwijdert {count} verlofaanvragen.",
        "warning": "Waarschuwing: Deze actie kan niet ongedaan worden gemaakt. Alle verlofgeschiedenis wordt permanent verwijderd en saldo's worden gereset.",
        "confirm_description": "Hierdoor worden {count} verlofaanvragen permanent verwijderd en alle saldi gereset.",
        "button": "Wis je verlofgeschiedenis",
        "confirm_button": "Bevestig dat je je geschiedenis hebt gewist"
      },
      "restore": {
        "title": "Herstellen vanuit back-up",
        "description": "Upload een back-up JSON-bestand om uw werkruimtegegevens te herstellen. Hiermee worden alle bestaande gegevens vervangen.",
        "warning": "Waarschuwing: Bij het herstellen worden alle huidige gebruikers, verloftypen, verlofaanvragen, afdelingen en saldi vervangen. Alleen de eigenaar van de werkruimte kan deze actie uitvoeren.",
        "select_file": "Selecteer back-upbestand",
        "backup_details": "Back-updetails",
        "file": "Bestand",
        "version": "Versie",
        "created": "Gemaakt",
        "confirm_prompt": "Typ RESTORE om te bevestigen",
        "confirm_description": "Hiermee worden alle bestaande gegevens permanent vervangen door de back-up.",
        "button": "Bevestig herstel",
        "restoring": "Herstellen...",
        "success": "Herstel succesvol voltooid!"
      }
    }
  },
  "audit": {
    "page_title": "Auditspoor",
    "page_subtitle": "Bekijk alle wijzigingen die in uw werkruimte zijn aangebracht.",
    "super_admin_label": "(Superbeheerder)",
    "entries_count": "totaal aantal vermeldingen",
    "filter": {
      "action_label": "Actietype",
      "all_actions": "Alle acties",
      "entity_label": "Entiteitstype",
      "all_entities": "Alle entiteiten",
      "user_label": "Gewijzigd door",
      "all_users": "Alle gebruikers"
    },
    "action": {
      "user_updated": "Gebruiker bijgewerkt",
      "user_deleted": "Gebruiker verwijderd",
      "user_imported": "Gebruiker geïmporteerd",
      "leave_requested": "Verzoek om verlof",
      "leave_approved": "Verlof goedgekeurd",
      "leave_rejected": "Verlof afgewezen",
      "leave_cancelled": "Verlof geannuleerd",
      "leave_type_created": "Type verlof aangemaakt",
      "leave_type_updated": "Type blad bijwerken",
      "leave_type_deleted": "Type verwijderen",
      "balance_adjusted": "Balans aangepast",
      "department_created": "Afdeling opgericht",
      "department_updated": "Afdeling bijgewerkt",
      "department_deleted": "Afdeling verwijderd",
      "audit_log_deleted": "Auditlogboek verwijderd"
    },
    "table": {
      "date": "Datum",
      "user": "Gebruiker",
      "action": "Actie",
      "entity": "Entiteit",
      "details": "Details"
    },
    "no_entries": "Geen auditlogboekvermeldingen gevonden"
  },
  "billing": {
    "page_title": "Facturering en abonnementen",
    "page_subtitle": "Beheer uw abonnements- en factuurgegevens",
    "access_denied": {
      "title": "Toegang geweigerd",
      "message": "Alleen de eigenaar van de werkruimte kan de facturering bekijken en beheren.",
      "button": "Terug naar het dashboard"
    },
    "current_plan": {
      "title": "Huidig ​​plan"
    },
    "status": {
      "none": "Geen abonnement"
    },
    "discount_badge": "{percent}% korting toegepast",
    "trial_info": {
      "title": "Proefperiode eindigt op {datum}",
      "days_remaining": "{dagen} dagen resterend"
    },
    "renewal_info": {
      "title": "Volgende factuurdatum"
    },
    "action": {
      "upgrade": "Upgrade naar Pro",
      "view_plans": "Bekijk alle plannen",
      "manage": "Abonnement beheren"
    },
    "plan": {
      "trial": "Gratis proefperiode",
      "free": "Vrij",
      "pro": "Pro",
      "business": "Bedrijf"
    },
    "feature": {
      "up_to_5_users": "Maximaal 5 gebruikers",
      "up_to_50_users": "Tot 50 gebruikers",
      "unlimited_users": "Onbeperkt aantal gebruikers",
      "basic": "Basisfuncties",
      "trial_14days": "14 dagen proefperiode",
      "unlimited_requests": "Onbeperkt aantal verlofaanvragen",
      "slack_integration": "Slack-integratie",
      "planner": "Plannerweergave",
      "custom_leave_types": "Aangepaste verlofsoorten",
      "approval_workflows": "Goedkeuringsworkflows",
      "priority_support": "Prioriteitsondersteuning",
      "multi_team": "Ondersteuning voor meerdere teams",
      "analytics": "Geavanceerde analyses",
      "api_access": "API-toegang",
      "dedicated_support": "Toegewijde ondersteuning"
    }
  },
  "upgrade": {
    "page_title": "Kies uw plan",
    "page_subtitle": "Eenvoudige, transparante prijsstelling. Geen kosten per gebruiker.",
    "plan_badge": "Meest populair",
    "period": {
      "month": "/maand",
      "year": "/jaar"
    },
    "yearly_savings": "of EUR {jaarlijks}/jaar (bespaar {procent}%)",
    "loading": "Plannen laden...",
    "guarantee": {
      "title": "30 dagen geld-terug-garantie",
      "description": "Niet tevreden? Dan krijgt u uw geld volledig terug, zonder vragen."
    },
    "faq": {
      "title": "Veelgestelde vragen",
      "q1": "Kan ik mijn plannen later nog wijzigen?",
      "a1": "Ja, u kunt op elk moment upgraden of downgraden. Wijzigingen worden direct van kracht en worden naar rato berekend.",
      "q2": "Welke betaalmethoden accepteert u?",
      "a2": "Wij accepteren alle gangbare creditcards (Visa, Mastercard, American Express) via onze beveiligde betalingsprovider Stripe.",
      "q3": "Is er sprake van een contract of een verbintenis?",
      "a3": "Nee, alle abonnementen zijn maandelijks opzegbaar. Je kunt op elk moment kosteloos opzeggen.",
      "q4": "Wat gebeurt er als ik mijn gebruikerslimiet bereik?",
      "a4": "U wordt gevraagd om over te stappen naar een hoger abonnement. Bestaande gebruikers behouden toegang."
    },
    "contact_note": "Heeft u vragen? Neem contact met ons op via",
    "current_plan_badge": "Huidig ​​plan",
    "button": {
      "upgrade": "Upgrade naar {plan}",
      "start_trial": "Start gratis proefperiode"
    }
  },
  "login": {
    "processing_title": "Je wordt ingelogd...",
    "processing_message": "Even geduld alstublieft terwijl we uw inloggegevens van Slack verifiëren.",
    "subtitle": "Beheer de verlofaanvragen van je teamleden eenvoudig.",
    "slack_button": "Voeg toe aan Slack",
    "existing_user_text": "Gebruik je Unplug al?",
    "existing_user_info": "Open de app in Slack en klik op Beheerdersdashboard om in te loggen.",
    "terms_text": "Door verder te gaan",
    "error": {
      "workspace_not_found": "Werkruimte niet gevonden. Controleer de URL.",
      "invalid_response": "Ongeldige reactie van de server.",
      "generic": "Aanmelden mislukt",
      "please_retry": "Aanmelden mislukt. Probeer het opnieuw."
    }
  },
  "help": {
    "page_title": "Helpcentrum",
    "page_subtitle": "Vind antwoorden en leer hoe je Unplug gebruikt.",
    "action": {
      "restart_tour": "Restart Tour"
    },
    "search": {
      "placeholder": "Zoek in helpartikelen, veelgestelde vragen...",
      "results": "Er zijn {articles} artikelen en {faqs} FAQ's gevonden die overeenkomen met {query}."
    },
    "quick_link": {
      "getting_started": "Aan de slag",
      "faqs": "Veelgestelde vragen",
      "contact_support": "Neem contact op met de ondersteuning.",
      "tour": "Neem deel aan de rondleiding"
    }
  },
  "profile": {
    "page_title": "Profielinstellingen",
    "personal_info": "Persoonlijke gegevens",
    "name_label": "Volledige naam",
    "email_label": "E-mail",
    "department_label": "Afdeling",
    "location_label": "Locatie",
    "manager_label": "Manager",
    "start_date_label": "Startdatum",
    "save_button": "Wijzigingen opslaan",
    "preferences": "Voorkeuren",
    "language_label": "Taal",
    "timezone_label": "Tijdzone"
  },
  "planner": {
    "page_title": "Planner",
    "page_subtitle": "Visuele teamkalender met alle afwezigheden",
    "feature_name": "Planner",
    "feature_description": "Visuele teamkalender met alle afwezigheden in één oogopslag",
    "empty_state": "Geen teamleden gevonden",
    "filter": {
      "pending_request": "Lopend verzoek",
      "filter_by": "Filteren op",
      "department": "Afdeling",
      "all_departments": "Alle afdelingen",
      "location": "Locatie",
      "all_locations": "Alle locaties"
    },
    "export": {
      "button": "Exporteren",
      "title": "Verlofgegevens exporteren",
      "format": "Exportformaat",
      "buddy_payroll": "Buddy Payroll",
      "generic_csv": "Algemene CSV",
      "date_range": "Datumbereik",
      "departments": "Afdelingen"
    },
    "legend": {
      "approved": "Goedgekeurd",
      "pending": "In behandeling",
      "holiday": "Feestdag",
      "holidays": "Feestdagen",
      "weekend": "Weekend",
      "non_working": "Niet-werkdag",
      "partial_day": "Afwezigheden korter dan een dag"
    },
    "no_data": "Geen afwezigheden om weer te geven"
  },
  "error": {
    "network": "Netwerkfout. Controleer uw verbinding.",
    "unauthorized": "U bent niet gemachtigd om deze handeling uit te voeren.",
    "not_found": "De gevraagde bron is niet gevonden.",
    "server": "Serverfout. Probeer het later opnieuw.",
    "validation": "Controleer het formulier op fouten.",
    "generic": "Er is iets misgegaan. Probeer het opnieuw.",
    "session_expired": "Je sessie is verlopen. Log opnieuw in."
  },
  "success": {
    "saved": "Wijzigingen succesvol opgeslagen.",
    "deleted": "Succesvol verwijderd.",
    "created": "Succesvol aangemaakt.",
    "updated": "Succesvol bijgewerkt.",
    "submitted": "Succesvol verzonden.",
    "sent": "Succesvol verzonden."
  },
  "weekday": {
    "monday": "Maandag",
    "tuesday": "Dinsdag",
    "wednesday": "Woensdag",
    "thursday": "Donderdag",
    "friday": "Vrijdag",
    "saturday": "Zaterdag",
    "sunday": "Zondag",
    "mon": "ma",
    "tue": "di",
    "wed": "woensdag",
    "thu": "Do",
    "fri": "vr",
    "sat": "Zat",
    "sun": "Zon"
  },
  "month": {
    "january": "Januari",
    "february": "Februari",
    "march": "Maart",
    "april": "april",
    "may": "Kunnen",
    "june": "juni",
    "july": "juli",
    "august": "augustus",
    "september": "september",
    "october": "oktober",
    "november": "november",
    "december": "December",
    "jan": "Jan",
    "feb": "februari",
    "mar": "Mar",
    "apr": "april",
    "may_short": "Kunnen",
    "jun": "juni",
    "jul": "juli",
    "aug": "Aug",
    "sep": "Sep",
    "oct": "oktober",
    "nov": "nov",
    "dec": "Dec"
  },
  "language": {
    "en": "Engels",
    "es": "Spaans",
    "fr": "Frans",
    "de": "Duits",
    "it": "Italiaans",
    "pt": "Portugees",
    "pl": "Pools",
    "nl": "Nederlands",
    "sv": "Zweeds",
    "no": "Noors"
  },
  "leave_type_name": {
    "Vacation": "Vakantie",
    "Vacation Leave": "Vakantieverlof",
    "Annual Leave": "Jaarlijks verlof",
    "Unpaid Vacation": "Onbetaald verlof",
    "Unpaid Leave": "Onbetaald verlof",
    "Sick Leave": "Ziekteverlof",
    "Sick Leave (Full Pay)": "Ziekteverlof (volledig salaris)",
    "Maternity Leave": "Zwangerschapsverlof",
    "Paternity Leave": "Vaderschapsverlof",
    "Parental Leave": "Ouderschapsverlof",
    "Bereavement Leave": "Rouwverlof",
    "Marriage Leave": "Huwelijksverlof",
    "Jury Leave": "Juryverlof",
    "Jury Duty": "Juryplicht",
    "Work Travel": "Zakenreis",
    "Working Remotely": "Thuiswerken",
    "Remote Work": "Thuiswerken",
    "Work From Home": "Thuiswerken",
    "Personal Day": "Persoonlijke dag",
    "TOIL": "Compensatieverlof",
    "Time Off In Lieu": "Compensatieverlof",
    "Compassionate Leave": "Bijzonder verlof",
    "Study Leave": "Studieverlof",
    "Training": "Training",
    "Public Holiday": "Feestdag"
  }
}